/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

(function($) {

  function heroSliderAutoplay(){
    $('.slide-m-next-home-hero-slider').trigger('click');
  }

  setInterval(heroSliderAutoplay, 4000);

})(jQuery);